import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["name", "properties"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { resolveAwsSdkSigV4AConfig, resolveAwsSdkSigV4Config } from "@aws-sdk/core";
import { signatureV4CrtContainer } from "@aws-sdk/signature-v4-multi-region";
import { resolveParams } from "@smithy/middleware-endpoint";
import { getSmithyContext, normalizeProvider } from "@smithy/util-middleware";
import { defaultEndpointResolver } from "../endpoint/endpointResolver";
var createEndpointRuleSetHttpAuthSchemeParametersProvider = function createEndpointRuleSetHttpAuthSchemeParametersProvider(defaultHttpAuthSchemeParametersProvider) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config, context, input) {
      var _getSmithyContext, _getSmithyContext$com, _getSmithyContext$com2;
      var defaultParameters, instructionsFn, endpointParameters;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (input) {
                _context.next = 2;
                break;
              }
              throw new Error("Could not find `input` for `defaultEndpointRuleSetHttpAuthSchemeParametersProvider`");
            case 2:
              _context.next = 4;
              return defaultHttpAuthSchemeParametersProvider(config, context, input);
            case 4:
              defaultParameters = _context.sent;
              instructionsFn = (_getSmithyContext = getSmithyContext(context)) === null || _getSmithyContext === void 0 ? void 0 : (_getSmithyContext$com = _getSmithyContext.commandInstance) === null || _getSmithyContext$com === void 0 ? void 0 : (_getSmithyContext$com2 = _getSmithyContext$com.constructor) === null || _getSmithyContext$com2 === void 0 ? void 0 : _getSmithyContext$com2.getEndpointParameterInstructions;
              if (instructionsFn) {
                _context.next = 8;
                break;
              }
              throw new Error("getEndpointParameterInstructions() is not defined on `".concat(context.commandName, "`"));
            case 8:
              _context.next = 10;
              return resolveParams(input, {
                getEndpointParameterInstructions: instructionsFn
              }, config);
            case 10:
              endpointParameters = _context.sent;
              return _context.abrupt("return", Object.assign(defaultParameters, endpointParameters));
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};
var _defaultS3HttpAuthSchemeParametersProvider = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config, context, input) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = getSmithyContext(context).operation;
            _context2.next = 3;
            return normalizeProvider(config.region)();
          case 3:
            _context2.t1 = _context2.sent;
            if (_context2.t1) {
              _context2.next = 6;
              break;
            }
            _context2.t1 = function () {
              throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
            }();
          case 6:
            _context2.t2 = _context2.t1;
            return _context2.abrupt("return", {
              operation: _context2.t0,
              region: _context2.t2
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function _defaultS3HttpAuthSchemeParametersProvider(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var defaultS3HttpAuthSchemeParametersProvider = createEndpointRuleSetHttpAuthSchemeParametersProvider(_defaultS3HttpAuthSchemeParametersProvider);
function createAwsAuthSigv4HttpAuthOption(authParameters) {
  return {
    schemeId: "aws.auth#sigv4",
    signingProperties: {
      name: "s3",
      region: authParameters.region
    },
    propertiesExtractor: function propertiesExtractor(config, context) {
      return {
        signingProperties: {
          config: config,
          context: context
        }
      };
    }
  };
}
function createAwsAuthSigv4aHttpAuthOption(authParameters) {
  return {
    schemeId: "aws.auth#sigv4a",
    signingProperties: {
      name: "s3",
      region: authParameters.region
    },
    propertiesExtractor: function propertiesExtractor(config, context) {
      return {
        signingProperties: {
          config: config,
          context: context
        }
      };
    }
  };
}
var createEndpointRuleSetHttpAuthSchemeProvider = function createEndpointRuleSetHttpAuthSchemeProvider(defaultEndpointResolver, defaultHttpAuthSchemeResolver, createHttpAuthOptionFunctions) {
  var endpointRuleSetHttpAuthSchemeProvider = function endpointRuleSetHttpAuthSchemeProvider(authParameters) {
    var _endpoint$properties;
    var endpoint = defaultEndpointResolver(authParameters);
    var authSchemes = (_endpoint$properties = endpoint.properties) === null || _endpoint$properties === void 0 ? void 0 : _endpoint$properties.authSchemes;
    if (!authSchemes) {
      return defaultHttpAuthSchemeResolver(authParameters);
    }
    var options = [];
    var _iterator = _createForOfIteratorHelper(authSchemes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var scheme = _step.value;
        var resolvedName = scheme.name,
          _scheme$properties = scheme.properties,
          properties = _scheme$properties === void 0 ? {} : _scheme$properties,
          rest = _objectWithoutProperties(scheme, _excluded);
        var name = resolvedName.toLowerCase();
        if (resolvedName !== name) {
          console.warn("HttpAuthScheme has been normalized with lowercasing: `".concat(resolvedName, "` to `").concat(name, "`"));
        }
        var schemeId = void 0;
        if (name === "sigv4a") {
          schemeId = "aws.auth#sigv4a";
          var sigv4Present = authSchemes.find(function (s) {
            var name = s.name.toLowerCase();
            return name !== "sigv4a" && name.startsWith("sigv4");
          });
          if (!signatureV4CrtContainer.CrtSignerV4 && sigv4Present) {
            continue;
          }
        } else if (name.startsWith("sigv4")) {
          schemeId = "aws.auth#sigv4";
        } else {
          throw new Error("Unknown HttpAuthScheme found in `@smithy.rules#endpointRuleSet`: `".concat(name, "`"));
        }
        var createOption = createHttpAuthOptionFunctions[schemeId];
        if (!createOption) {
          throw new Error("Could not find HttpAuthOption create function for `".concat(schemeId, "`"));
        }
        var option = createOption(authParameters);
        option.schemeId = schemeId;
        option.signingProperties = _objectSpread(_objectSpread(_objectSpread({}, option.signingProperties || {}), rest), properties);
        options.push(option);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return options;
  };
  return endpointRuleSetHttpAuthSchemeProvider;
};
var _defaultS3HttpAuthSchemeProvider = function _defaultS3HttpAuthSchemeProvider(authParameters) {
  var options = [];
  switch (authParameters.operation) {
    default:
      {
        options.push(createAwsAuthSigv4HttpAuthOption(authParameters));
        options.push(createAwsAuthSigv4aHttpAuthOption(authParameters));
      }
  }
  return options;
};
export var defaultS3HttpAuthSchemeProvider = createEndpointRuleSetHttpAuthSchemeProvider(defaultEndpointResolver, _defaultS3HttpAuthSchemeProvider, {
  "aws.auth#sigv4": createAwsAuthSigv4HttpAuthOption,
  "aws.auth#sigv4a": createAwsAuthSigv4aHttpAuthOption
});
export var resolveHttpAuthSchemeConfig = function resolveHttpAuthSchemeConfig(config) {
  var config_0 = resolveAwsSdkSigV4Config(config);
  var config_1 = resolveAwsSdkSigV4AConfig(config_0);
  return _objectSpread({}, config_1);
};